import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import DiamondMark from "@/components/DiamondMark";

// Handles the Google OAuth return: {origin}/admin#session_id=...
export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState({}, document.title, "/admin");
        // checkAuth confirms device status (a held device resolves to the awaiting screen).
        await checkAuth();
        navigate("/admin", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-bd-black flex items-center justify-center">
      <div className="text-center">
        <DiamondMark size={44} className="mx-auto mb-6 animate-pulse" />
        <p className="text-bd-ivory/50 text-sm tracking-widest uppercase">Establishing secure session…</p>
      </div>
    </div>
  );
}
